import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getMitraByNetworkCode(params) {
	return client.get("general/get-member-by-network-code", {
		params: params,
	});
}

function getMitraByIdentityNum(params) {
	return client.get("general/get-status-by-identity", {
		params: params,
	});
}

function getMitraIdentityUsed(params) {
	return client.get("general/get-status-by-identity", {
		params: params,
	});
}

function addRegistration(params) {
	return client.post("binary/registration", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function addPraMitra(params) {
	return client.post("binary/pra-mitra", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function addActivation(params) {
	return client.post("binary/activation", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function addActivationMitra(params) {
	return client.post("membership/activation", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function addCloneMitra(params) {
	return client.post("binary/registration/clone", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getMitraByNetworkCode,
	getMitraByIdentityNum,
	getMitraIdentityUsed,
	addRegistration,
	addPraMitra,
	addActivation,
	addActivationMitra,
	addCloneMitra
};